/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import BackgroundImage from '../assets/images/background.jpg'
import ValidateCaptcharModal from '../containers/captchar/ValidateCaptcharModal'
import {  LoadingOverlay } from '../components/common'
// import { toast } from 'react-toastify'
import { UserContext } from '../stores/UserStore'

const Background = styled.div`
  background: url(${BackgroundImage}) no-repeat center center fixed;
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.background };
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.gray};
  font-weight: bold;
`

const Refresh = (props) => {
  const history = useHistory()
  const { refreshSession, applications, app, loadApp, redirect } = useContext(UserContext)
  const [isLoading, setLoading] = useState(true)
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    if (applications) {
      loadApp().then().catch(error => {
        history.replace('/select-app')
      })
    } 
  }, [applications])     

  useEffect(() => {
    if (app) {
      refreshSession().then((token) => {
        if (app.link && app.link.indexOf(process.env.REACT_APP_DOMAIN) === -1) {
          setLoading(false)
          setOpen(true)
        } else {
          setLoading(true)
          redirect(token).then(() => { setLoading(true) })
          // window.location.replace(app.link)
        }
      }).catch(err => {
        history.replace('/logout?app='+app.id)
      })
    } 
  }, [app])

  const onCaptcharChange = (value) => {
    if (value) {
      setLoading(true)
      redirect(value).then(() => { setLoading(true) })
    }
  }

  return (
    <Background>
      <ValidateCaptcharModal isOpen={isOpen} isLoading={isLoading} onChange={onCaptcharChange} /> 
      <LoadingOverlay visible={isLoading}/>
    </Background>
  )
}

export default Refresh